import LoadingIcon from "@/assets/images/icons/loading-white.svg?inline";

import {
  CONFIRM_USER_EMAIL,
  RESENT_CONFIRMATION_TOKEN
} from "../gql/AuthQueries";

export default {
  name: "confirmation_email",

  data() {
    return {
      isTokenInvalid: false,
      email: "",
      submitLoading: false,
      errorTitle: "",

      code: "",
      isSubmitCode: false
    };
  },

  props: {
    isBuyerRegistration: {
      type: Boolean,
      default: false
    }
  },

  mounted: function() {
    this.email = localStorage.getItem("signupEmail");
  },

  methods: {
    resendToken() {
      this.submitLoading = true;

      this.$apollo
        .mutate({
          mutation: RESENT_CONFIRMATION_TOKEN,
          variables: {
            email: this.email
          }
        })
        .then(({ data: { resendConfirmationToken } }) => {
          if (resendConfirmationToken.status == "200") {
            this.code = "";
            this.isTokenInvalid = false;
            // if (this.isBuyerRegistration) {
            //   // this.$emit("goToPersonalizeSlide");
            // } else {
            //   this.$router.push({
            //     name: "confirm_email",
            //     params: { email: this.email }
            //   });
            // }
          }
        })
        .catch(mutationError => {
          const errors = mutationError.graphQLErrors;

          for (let error in errors) {
            this.$toasted.error(errors[error].message);
          }
        })
        .then(() => {
          this.submitLoading = false;
        });
    },

    submitEmailPin() {
      this.isSubmitCode = true;

      this.$apollo
        .mutate({
          mutation: CONFIRM_USER_EMAIL,
          variables: {
            confirmationToken: this.code
          }
        })
        .then(
          ({
            data: {
              confirmUserEmail: { user, accessToken, needRedirect }
            }
          }) => {
            if (needRedirect) {
              this.$router.push({
                name: "home"
              });
            } else {
              if (typeof localStorage !== "undefined" && accessToken) {
                localStorage.setItem("AUTH_TOKEN", accessToken);
              }

              this.$emit("userLoggedIn");
              this.$store.commit("setUserInfo", user);

              if (user.role == "buyer") {
                if (this.isBuyerRegistration) {
                  this.$emit("goToPersonalizeSlide");
                } else {
                  this.$router.push({
                    name: "personalize"
                  });
                }
              } else {
                if (user.needUploadAgentDocuments == true) {
                  this.$router.push({
                    name: "identity_documents"
                  });
                } else {
                  this.$router.push({
                    name: "agent_profile_info"
                  });
                }
              }
            }
          }
        )
        .catch(mutationError => {
          const errors = mutationError.graphQLErrors;

          for (let error in errors) {
            this.$toasted.error(errors[error].message);
            this.errorTitle = errors[error].message;
          }
          this.isTokenInvalid = true;
        })
        .then(() => {
          this.isSubmitCode = false;
        });
    }
  },

  components: {
    LoadingIcon
  }
};
